import { useTranslation } from 'react-i18next';
import { useColumns } from './table.definition';
import { useFilter } from './filter.definition';
import { useActions } from './action.definition';
import { DataTable, Title } from '../../../components/common';
import { EntityQueryKey } from '../../../query/query.keys';
import { DocumentService } from '../../../api/document/document.service';

export function DocumentList() {
  const { t } = useTranslation();
  const columns = useColumns();
  const filter = useFilter();
  const [rowActions, groupActions, toolbarActions] = useActions();

  return (
    <>
      <Title text={t('document:list.pageTitle')} />
      <DataTable
        id="document-list"
        queryKey={EntityQueryKey.Document}
        columns={columns}
        fetchData={DocumentService.listFn}
        filter={filter}
        rowActions={rowActions}
        groupActions={groupActions}
        toolbarActions={toolbarActions}
      />
    </>
  );
}